import React from "react";
import styles from "./css/GraphsCard.module.css";
import { FavoriteIcon } from "@/icons/FavoriteIcon";
import { InformationIcon } from "@/icons/InformationIcon";
interface GraphsCardProps {
  title: string;
  subtitle?: string;
  isFavourite?: boolean;
  children: React.ReactNode;
  setFavourite: (tabName: string, isFavourite: boolean) => void;
  id: string;
  showFavorite?: boolean;
  numberOfCompare?: number;
  size?: "big" | "small" | "veryBig" | "verySmall";
    disclaimer?: {
    text: string;
    type?: 'info' | 'warning';  
  };
}

export const GraphsCard: React.FC<GraphsCardProps> = ({ title, subtitle, isFavourite = false, children, setFavourite, 
  id, showFavorite = true, numberOfCompare=0, size="small", disclaimer }) => {


    let cardClassName = `${styles.container}`;
    if(size === "big") {
        cardClassName += ` ${styles.bigCard}`;
    }
    else if(size === "veryBig") {
        cardClassName += ` ${styles.veryBigCard}`;
    }
    else if(size === "verySmall") {
        cardClassName += ` ${styles.verySmallCard}`;
    }
    else if(numberOfCompare === 3) {
        cardClassName += ` ${styles.xsSmallCard}`;
    }
    else if(numberOfCompare > 0) {
        cardClassName += ` ${styles.compareCard}`;
    }
    
    return (
        <div className={cardClassName}>
            <div className={styles.titleContainer}>
              {showFavorite && (
                <div onClick={() => setFavourite(id, !isFavourite)} className="cursor-pointer">
                  <FavoriteIcon isFavourite={isFavourite}/>
                </div>
              )}
              <div className={styles.title} >
                <span className="ml-2">{title}</span> 
                {disclaimer && disclaimer.text && (
                    <div className="group relative inline-block mr-2 ml-3 z-[9999]">
                        <InformationIcon className="cursor-help text-[#49454F] opacity-70" width="16" height="16"/>
                        <div className="absolute hidden group-hover:block z-[9999] top-full left-1/2 transform -translate-x-1/2 translate-y-1 
                            bg-white border border-[#c3cfe7] rounded-md shadow-lg p-2 min-w-[200px] max-w-[250px]">
                            <div className="text-[10px] text-[#49454F]">{disclaimer.text}</div>
                            <div className="absolute top-[-5px] left-1/2 transform -translate-x-1/2 rotate-45 w-2 h-2 
                                bg-white border-l border-t border-[#c3cfe7]"></div>
                        </div>
                    </div>
                )}
              </div>
            </div>
            <div className={styles.graphContainer}>
                {children}
            </div>
            {subtitle && (
                <div className={styles.subtitleContainer}>
                    <span className={styles.subtitle}>{subtitle}</span>
                </div>
            )}
        </div>
    );
};
